var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/core-js/modules/_redefine-all.js
// module id = ../../../../core-js/modules/_redefine-all.js
// module chunks = 15